module.exports = __webpack_public_path__ + "static/media/ShowAssignedTeachers.e76a928f.png";